export default "<b>Enkelt</b> att komma igång och använda, ger god översikt och vägledning över det egna arbetet";